import { create } from 'zustand';
import { ReactNode, useEffect } from 'react';

interface PageHeaderState {
  actions: ReactNode | null;
  setActions: (actions: ReactNode | null) => void;
  clearActions: () => void;
}

export const usePageHeaderStore = create<PageHeaderState>((set) => ({
  actions: null,
  setActions: (actions) => set({ actions }),
  clearActions: () => set({ actions: null }),
}));

export function usePageHeaderActions(actions: ReactNode, deps: any[] = []) {
  const setActions = usePageHeaderStore((s) => s.setActions);
  const clearActions = usePageHeaderStore((s) => s.clearActions);

  useEffect(() => {
    setActions(actions);
    return () => {
      clearActions();
    };
  }, deps);
}
